export interface FactorPreset {
  id: string;
  value: number;
}

export const FACTOR_PRESETS: readonly FactorPreset[] = [
  { id: 'twelve', value: 12 },
  { id: 'sixty', value: 60 },
  { id: 'kilo', value: 1024 },
  { id: 'prime-2027', value: 2027 },
  { id: 'perfect-6', value: 6 },
];
